// src/components/button/NewsCategorySelector.tsx

import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material'
import { MouseEvent } from 'react'

import { languageConstants as LC } from '../../constants'

type Props = {
  data?: { label: string; value: string }[]
  onChange: (_event: MouseEvent<HTMLElement>, newValue: string) => void
  value: string
}

export const NewsCategorySelector = ({
  data = [
    { label: LC.NEWSCATEGORY_CONTRACT, value: LC.NEWSCATEGORY_CONTRACT },
    { label: LC.NEWSCATEGORY_OBJECT, value: LC.NEWSCATEGORY_OBJECT },
  ],
  onChange,
  value,
}: Props) => (
  <ToggleButtonGroup onChange={onChange} value={value}>
    {data.map(role => (
      <Tooltip title={role.label} key={role.label}>
        <ToggleButton value={role.value}>{role.label}</ToggleButton>
      </Tooltip>
    ))}
  </ToggleButtonGroup>
)
